/** Available dashboard queue types. */
export enum DashboardQueuesType {
  All = 'all',
  Agent = 'agent',
  Favourite = 'favourite',
  Archived = 'archived',
}
